import { token } from '@atlaskit/tokens';
import React from 'react';
import Spinner from '@atlaskit/spinner';
import { environment, envs } from '../../services/environment';
import { css } from '@compiled/react';

const loginRedirectStyles = css({
  margin: `${token('space.300')} 0`,
});

export function LoginRedirect() {
  if (environment().name === envs.PROD) {
    window.location.href = 'https://id.atlassian.com/login?continue=' + environment().url;
  } else {
    window.location.href = 'https://id.stg.internal.atlassian.com/login?continue=' + environment().url;
  }
  return (
    <div css={loginRedirectStyles}>
      Please wait... <Spinner />
    </div>
  );
}
